import React from "react";
import { ITeamMember, TeamMember } from "../team-member";
import style from "./style.module.css";

export interface ITeamOverviewProps {
    members: ITeamMember[];
}

export function TeamOverview(props: ITeamOverviewProps) {
    return (
        <section className={style.teamOverview}>
            {
                props.members.map((member: ITeamMember, index: number) => {
                    return <TeamMember key={member.name + index} member={member} />
                })
            }
        </section>
    )
}